function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M14.15 22H9.87c-1.53 0-2.67-1.24-2.38-2.57l.7-3.08h7.64l.7 3.08c.32 1.41-.75 2.57-2.38 2.57z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M18.77 13.74l-2.94 2.61H8.19l-2.94-2.61c-1.71-1.4-1.71-2.48-.41-4.13l5.19-6.57c.36-.45.78-.76 1.23-.92a2.27 2.27 0 011.5 0c.45.16.87.47 1.23.92l5.19 6.57c1.3 1.65 1.24 2.67-.41 4.13z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.76 2.12v4.85c0 .41-.34.75-.75.75s-.75-.34-.75-.75V2.12a2.27 2.27 0 011.5 0z"
})));